// extracted by mini-css-extract-plugin
export var section = "section-module--section--RG9F+";